module.exports = __webpack_public_path__ + "static/image/service/m/taste@3x.jpg?e2eb0533";